import React from 'react';
import FooterWrapper from '../components/FooterWrapper';

const AGB = () => {
  return (
    <div className="min-h-screen bg-black-pure flex flex-col overflow-hidden">
      
      <section className="relative z-10 bg-black-pure pt-32 pb-24">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="font-geist text-white text-[24px] font-normal mb-8">ALLGEMEINE GESCHÄFTSBEDINGUNGEN</h1>
          
          <div className="space-y-8 font-geist">
            <div>
              <p className="text-[#787c87] text-sm font-normal mb-4">
                Zuletzt geändert: September 2025
              </p>
              <div className="h-px bg-gray-800 my-6"></div>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">I. Geltungsbereich /Vertragsschluss</h2>
              <p className="text-[#787c87] text-sm font-normal mb-4">
                1.1 Die BLCKS e.U., FN 642541p, Heinrich-Casper-Gasse 29/9, 8010 Graz, hello@blcks.at (in der Folge als BLCKS bezeichnet) schließt Verträge ausschließlich unter Zugrundelegung dieser AGB ab. Die gegenständlichen Geschäftsbedingungen gelten auch für Auftragserweiterungen und Folgeaufträge sowie überhaupt für die gesamte Geschäftsbeziehung mit dem Kunden, ohne dass es in jedem Einzelfall einer erneuten Vereinbarung bedarf. Allfällige AGB von Kunden werden ausdrücklich nicht anerkannt.
              </p>
              <p className="text-[#787c87] text-sm font-normal">
                1.2 Der Vertrag kommt erst durch eine schriftliche Auftragsbestätigung seitens BLCKS zustande. Deren Inhalt in Verbindung mit dem Angebot ist für den Inhalt des Vertrages ausschließlich maßgebend. Vertragsänderungen oder -ergänzungen ebenso wie mündlich getroffene Vereinbarungen bedürfen zu ihrer Rechtsgültigkeit ausnahmslos der schriftlichen Bestätigung seitens BLCKS.
              </p>
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">II. Leistungen von BLCKS</h2>
              <h3 className="text-white text-base font-normal mb-2">1. Beratung</h3>
              <p className="text-[#787c87] text-sm font-normal mb-4">
                1.1 BLCKS unterstützt seine Kunden bei der Implementierung von KI-Anwendungen in der jeweiligen EDV-Systemumgebung des Kunden. Der Kunde nimmt zur Kenntnis, dass BLCKS, soferne der Auftrag keine Sonderprogrammierungen umfasst, die jeweiligen KI-Anwendungen nicht selbst entwickelt, sondern lediglich als Berater bei der Umsetzung von KI-Strategien fungiert.
              </p>
              <p className="text-[#787c87] text-sm font-normal mb-4">
                1.2 Auf das Vertragsverhältnis zwischen dem Kunden und den jeweiligen Entwicklern/Anbietern einer KI-Anwendung und deren Komponenten hat BLCKS keinen Einfluss. Inhalt und Umfang der Lizenz ergeben sich vielmehr aus dem Vertrag zwischen dem Kunden und dem Entwickler der KI-Anwendung bzw. allfälliger Sub-Anwendungen. BLCKS arbeitet auf der Grundlage dieser Nutzungsbedingungen der Entwickler und legt diese auch dem gegenständlichen Vertrag zu Grunde. Der Kunde anerkennt mit der Auftragserteilung ausdrücklich, dass diese Nutzungsbedingungen die Rechte und Pflichten von BLCKS (mit-)bestimmen.
              </p>
              <p className="text-[#787c87] text-sm font-normal mb-4">
                1.3 Der Kunde nimmt zur Kenntnis, dass BLCKS auf Grund der Vielfalt an KI-Anbietern und KI-Anwendungen nicht in der Lage ist, alle möglichen Lösungen und deren Funktionen zu kennen. BLCKS wird sich im Rahmen der mit dem Kunden vereinbarten Leistungsbeschreibung nach bestem Wissen bemühen, eine den Bedürfnissen des Kunden entsprechende Lösung umzusetzen, schuldet aber keineswegs eine spezifische Funktionalität und keinen Erfolg.
              </p>
              <p className="text-[#787c87] text-sm font-normal">
                1.4 Soweit vom Auftrag keine Sonderprogrammierungen oder proprietäre KI-Anwendungen von BLCKS umfasst sind, nimmt der Kunde zur Kenntnis, dass BLCKS auch auf den Funktionsumfang der jeweiligen KI-Anwendung keinen Einfluss hat. Mit der Beauftragung bestätigt der Kunde die Kenntnis des Leistungsumfangs der jeweiligen KI-Anwendung sowie allfälliger Sub-Anwendungen und dass die Beratung durch BLCKS den geforderten Funktionsumfang für die Zwecke des Kunden ausreichend dargelegt hat.
              </p>
            </div>

            {/* Add more sections as needed */}
            
            <div>
              <h3 className="text-white text-base font-normal mb-2">2. Sonderprogrammierungen</h3>
              <p className="text-[#787c87] text-sm font-normal mb-4">
                2.1 Soferne und soweit die Implementierung einer KI-Anwendung in der EDV-Systemumgebung des Kunden oder die Abbildung von dessen Geschäftsprozessen die Ausarbeitung und Entwicklung individueller Funktionen, Schnittstellen, Erweiterungen und/oder Zusatzprogrammen erforderlich macht, wird BLCKS den Kunden darauf hinweisen. Ohne gesonderte Beauftragung sind derartige Sonderprogrammierungen nicht vom Vertragsgegenstand erfasst.
              </p>
              {/* Add more paragraphs as needed */}
            </div>

            <div>
              <h3 className="text-white text-base font-normal mb-2">3. Schulungen</h3>
              <p className="text-[#787c87] text-sm font-normal mb-4">
                3.1 Beauftragt der Kunde BLCKS mit KI-Schulungen für Mitarbeiter, wird BLCKS mit dem Kunden vorab den wesentlichen Kursinhalt, die Modalitäten (Zeit, Ort etc.) und der Umfang des jeweiligen Kurses (Dauer und Anzahl der Einheiten) vereinbaren. Die konkrete Ausgestaltung der Einheiten und die Art der Vermittlung der Lehrinhalte obliegen jedoch alleine BLCKS bzw. den jeweiligen Schulungsleitern nach deren freier Entscheidung. Nachträgliche Änderungen des Schulungsinhalts bleiben vorbehalten.
              </p>
              {/* Add more paragraphs as needed */}
            </div>

            <div>
              <h3 className="text-white text-base font-normal mb-2">4. Förderungen</h3>
              <p className="text-[#787c87] text-sm font-normal">
                4.1 Für allfällige Förderungen des Kunden gelten ausschließlich die Vorgaben der jeweiligen Förderstellen (z.B. des Bundes bzw. des Landes). Für die diesbezüglichen Ansuchen und das Erfüllen der jeweiligen Voraussetzungen ist der Kunde selbst verantwortlich. BLCKS leistet keine Gewähr, macht keine Zusage und hat auch sonst nicht dafür einzustehen, dass eine beantragte Förderung gewährt wird.
              </p>
            </div>

            {/* Add remaining sections following the same pattern */}
            
            <div>
              <h2 className="text-white text-lg font-normal mb-3">III. Entgelt</h2>
              <p className="text-[#787c87] text-sm font-normal">
                1. Für die Unterstützung und Beratung bei der Implementierung einer KI-Anwendung, deren allfällige Wartung sowie für etwaige Sonderprogrammierungen hat der Kunde an BLCKS Zahlungen in der mit dem Kunden jeweils vereinbarten Höhe laut Angebot zu leisten.
              </p>
              {/* Add more paragraphs as needed */}
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">IV. Gewährleistung, Wartung, Haftung</h2>
              <h3 className="text-white text-base font-normal mb-2">1. Gewährleistung</h3>
              <p className="text-[#787c87] text-sm font-normal">
                1.1 BLCKS leistet Gewähr, dass Sonderprogrammierungen und deren Bestandteile frei von Schutzrechten Dritter sind, die eine vertragsgemäße Nutzung einschränken. Der Kunde wird BLCKS unverzüglich benachrichtigen, soferne ihm gegenüber Ansprüche wegen einer Verletzung von Schutzrechten geltend gemacht werden.
              </p>
              {/* Add more paragraphs as needed */}
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">V. Vertragsdauer/-auflösung</h2>
              <p className="text-[#787c87] text-sm font-normal">
                1. Verträge betreffend die Implementierung von KI-Anwendungen in der EDV-Systemumgebung des Kunden enden mit Umsetzung des Projekts. Zu einer laufenden Wartung der KI-Anwendung ist BLCKS nur verpflichtet, wenn dies vom Kunden ausdrücklich beauftragt wurde.
              </p>
              {/* Add more paragraphs as needed */}
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">VI. Grundsätze der Leistungserbringung</h2>
              <h3 className="text-white text-base font-normal mb-2">1. Pflichten von BLCKS</h3>
              <p className="text-[#787c87] text-sm font-normal">
                1.1 BLCKS wird die nach diesem Vertrag geschuldeten Beratungs- und Unterstützungs- sowie allfällige Wartungsleistungen unter bestmöglicher Wahrung der Kontinuität des Geschäftsbetriebs des Kunden erbringen.
              </p>
              {/* Add more paragraphs as needed */}
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">VII. Geheimhaltung, Datenschutz</h2>
              <p className="text-[#787c87] text-sm font-normal">
                1. Die Vertragsparteien verpflichten sich wechselseitig, alle im Rahmen der Anbahnung und Durchführung des Vertrages erhaltenen Kenntnisse, Daten und Informationen in Bezug auf die jeweils andere Partei, auch wenn diese im Einzelnen nicht als geheimhaltungspflichtig gekennzeichnet sind, zeitlich unbegrenzt vertraulich zu behandeln und nur für Zwecke der Durchführung dieses Vertrages zu verwenden.
              </p>
              {/* Add more paragraphs as needed */}
            </div>

            <div>
              <h2 className="text-white text-lg font-normal mb-3">IX. Schlussbestimmungen</h2>
              <p className="text-[#787c87] text-sm font-normal">
                1. Auf alle Rechtsfragen aus oder im Zusammenhang mit dem Vertrag zwischen BLCKS und Kunde einschließlich der Frage seines Zustandekommens und seiner Vor- und Nachwirkungen ist ausschließlich österreichisches Recht unter Ausschluss der nationalen und europäischen Kollisionsnormen anzuwenden.
              </p>
              {/* Add more paragraphs as needed */}
            </div>
          </div>
        </div>
      </section>
      
      <FooterWrapper />
    </div>
  );
};

export default AGB;
